var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _g, _rect, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIllustrationPlain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 63,
    viewBox: "0 0 92 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9452 7.48336C10.9962 7.22373 11.2238 7.0365 11.4884 7.0365L75.6864 7.0365C76.035 7.0365 76.2969 7.35481 76.2297 7.69687L65.5134 62.2278C65.4623 62.4875 65.2347 62.6747 64.9701 62.6747H1.10862C0.585722 62.6747 0.192951 62.1972 0.293781 61.6842L10.9452 7.48336Z",
    fill: "#4793F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0083 7.56158C11.0281 7.25647 11.2811 7.0365 11.5868 7.0365L75.7314 7.0365C76.0648 7.0365 76.3226 7.32903 76.2806 7.65979L69.3625 62.1908C69.3274 62.4674 69.1325 62.6747 68.8536 62.6747C63.6925 62.6747 15.4068 62.6747 3.66799 62.6747C2.66935 62.6747 2.03929 61.579 2.40685 60.6505C7.11029 48.7684 10.6785 12.655 11.0083 7.56158Z",
    fill: "#A8CCF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0296 7.51424C11.0543 7.22812 11.2914 7.0365 11.5785 7.0365L75.7733 7.0365C76.0915 7.0365 76.3442 7.30407 76.326 7.62174L73.206 62.1537C73.1893 62.4463 72.9883 62.6751 72.6952 62.6757C66.7691 62.6873 8.06238 62.8011 7.17415 62.7423C6.28966 62.6837 10.5614 12.9361 11.0296 7.51424Z",
    fill: "#648CFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0194 7.55262C11.0272 7.25293 11.2719 7.0365 11.5716 7.0365L75.8209 7.0365C76.1208 7.0365 76.3661 7.27523 76.3743 7.57497L77.8665 62.1059C77.875 62.4175 77.6558 62.6747 77.3441 62.6747C71.2539 62.6747 15.4499 62.6747 12.5556 62.6747C9.66752 62.6747 10.8734 13.1658 11.0194 7.55262Z",
    fill: "#2538BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0905 7.64923C11.0598 7.32445 11.3146 7.0365 11.6409 7.0365L75.8126 7.0365C76.1156 7.0365 76.3624 7.2715 76.3677 7.57443C76.4538 12.5018 77.2744 49.8499 82.5109 60.0952C82.6889 60.4435 82.5018 60.8614 82.1142 60.9147C71.3902 62.3894 27.2731 62.6451 21.5995 62.6721C21.2391 62.6738 20.9208 62.4394 20.8098 62.0965C15.5233 45.7566 13.5026 33.1504 11.0905 7.64923Z",
    fill: "#A8CCF8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0841 7.6373C11.0565 7.31411 11.3113 7.0365 11.6357 7.0365L75.8227 7.0365C76.1217 7.0365 76.3666 7.27384 76.3761 7.57265L76.666 16.7605L11.8274 16.3262L11.0841 7.6373Z",
    fill: "#4793F1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8743 22.3459H68.4546L69.4205 27.9263H63.8401L62.8743 22.3459Z",
    fill: "#648CFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0012 22.3459H58.5816L59.5474 27.9263H53.9671L53.0012 22.3459Z",
    fill: "#648CFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1279 22.3459H48.7083L49.6741 27.9263H44.0938L43.1279 22.3459Z",
    fill: "#648CFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5911 30.7163H70.1714L71.1373 36.2967H65.5569L64.5911 30.7163Z",
    fill: "#648CFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.718 30.7163H60.2984L61.2642 36.2967H55.6839L54.718 30.7163Z",
    fill: "#648CFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8452 30.7163H50.4256L51.3914 36.2967H45.811L44.8452 30.7163Z",
    fill: "#E7F1FD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9722 30.7163H40.5525L41.5184 36.2967H35.938L34.9722 30.7163Z",
    fill: "#E7F1FD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0991 30.7163H30.6795L31.6453 36.2967H26.065L25.0991 30.7163Z",
    fill: "#E7F1FD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0938 39.7316H71.6741L72.64 45.312H67.0596L66.0938 39.7316Z",
    fill: "#648CFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2207 39.7316H61.8011L62.7669 45.312H57.1865L56.2207 39.7316Z",
    fill: "#648CFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3481 39.7316H51.9285L52.8943 45.312H47.314L46.3481 39.7316Z",
    fill: "#648CFE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4749 39.7316H42.0552L43.0211 45.312H37.4407L36.4749 39.7316Z",
    fill: "#E7F1FD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6018 39.7316H32.1822L33.148 45.312H27.5676L26.6018 39.7316Z",
    fill: "#648CFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9375 48.7458H63.5179L64.4837 54.3262H58.9033L57.9375 48.7458Z",
    fill: "#648CFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0649 48.7458H53.6453L54.6111 54.3262H49.0308L48.0649 48.7458Z",
    fill: "#648CFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1919 48.7458H43.7723L44.7381 54.3262H39.1577L38.1919 48.7458Z",
    fill: "#E7F1FD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3188 48.7458H33.8992L34.8651 54.3262H29.2847L28.3188 48.7458Z",
    fill: "#E7F1FD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3475 37.9865C53.1436 42.1543 55.3521 46.6989 48.939 46.6064C43.5309 46.5283 44.6818 32.4598 55.7177 43.3387",
    stroke: "#2538BF",
    strokeWidth: 0.48726,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5437 43.9585C64.711 40.3274 51.3402 43.9634 51.3402 43.9634C57.0237 41.6627 67.0549 37.2985 78.0138 38.6599L78.5437 43.9585Z",
    fill: "#2538BF"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.2036,
    y: 5.54199,
    width: 47.063,
    height: 4.4519,
    transform: "rotate(132.19 89.2036 5.54199)",
    fill: "#FFBF39"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2492 44.1011L57.5968 40.4126C57.1465 38.2742 56.2893 37.7782 54.2982 37.4228L51.2492 44.1011Z",
    fill: "#C28030"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5441 0.747818C91.455 1.57344 91.5241 2.98114 90.6984 3.892L89.2035 5.54127L85.905 2.55143L87.3999 0.902166C88.2255 -0.00869842 89.6332 -0.0778024 90.5441 0.747818Z",
    fill: "#E7F1FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIllustrationPlain);
export default __webpack_public_path__ + "static/media/calendar-illustration-plain.969b6f14f7493821cb3b7cd0c5c86214.svg";
export { ForwardRef as ReactComponent };